<template>
  <content-panel>
    <template v-slot:search>
      <search-box class="search-box">
        <el-form :inline="true" size="mini" label-width="80px" :model="searchForm">
          <el-form-item label="产品编码">
            <el-input v-model.trim="searchForm.productCode" placeholder="请输入产品编码"></el-input>
          </el-form-item>
          <el-form-item label="产品名称">
            <el-input v-model.trim="searchForm.productName" placeholder="请输入产品名称"></el-input>
          </el-form-item>
          <el-form-item label="更新人员">
            <el-input v-model.trim="searchForm.userName" placeholder="请输入更新人员"></el-input>
          </el-form-item>
          <el-form-item label="更新时间">
            <form-date-range :form="searchForm" startKey="startDate" endKey="endDate" :usingTime="false"></form-date-range>
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button type="primary" size="small" @click="searchPage">搜索</el-button>
          <el-button class="orange-btn" size="small" @click="resetForm">重置</el-button>
        </template>
      </search-box>
    </template>
    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <el-button type="primary" size="mini" @click="addDialogVisible = true">新增</el-button>
        <el-button type="primary" size="mini" @click="importClearPrice" v-permission="'ec-pc-new#importClearPrice'">清仓销售价系数维护</el-button>
        <el-button type="primary" size="mini" @click="importPriceCoefficient" v-permission="'ec-pc-new#importPriceCoefficient'">产品价格系数维护导入</el-button>
        <el-button type="primary" size="mini" @click="importBasePrice" v-permission="'ec-pc-new#importBasePrice'">产品基础价格维护导入</el-button>
        <el-button type="primary" size="mini" @click="exportExcel">导出</el-button>
      </template>
      <el-table
        border
        ref="table"
        v-loading="loading"
        :height="maxTableHeight"
        :data="tableData.records"
        :header-cell-style="{ backgroundColor: '#F4F8FB' }"
      >
        <el-table-column :show-overflow-tooltip="true" prop="productCode" width="200" label="产品编码" fixed></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="productName" width="200" label="产品名称"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="retailPrice" label="基础零售价"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="dailyRetailPrice" label="A类价系数"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="retailPriceA" label="A类价"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="discountPriceClear" label="清仓销售价系数"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="discountPriceClearPrice" label="清仓销售价"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="updatedDate" width="160" label="更新时间"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="reason" width="160" label="最新调整原因"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="updatedBy" label="最新调整人"></el-table-column>
        <el-table-column width="150" fixed="right" label="操作" align="center">
          <template slot-scope="scope">
            <el-link type="primary" :underline="false" @click="handleEdit(scope.row)" v-permission="'ec-pc-new#retailpriceEdit'">编辑</el-link>
            <el-link type="primary" :underline="false" @click="handleRecord(scope.row)">调整记录</el-link>
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div class="footerBox">
          <el-pagination
            background
            @size-change="onSizeChange"
            @current-change="onCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[30, 100, 500, 1000]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </div>
      </template>
    </table-panel>

    <add-dialog :visible.sync="addDialogVisible" @success="onSearch" v-if="addDialogVisible" />

    <!-- 编辑弹窗 -->
    <edit-dialog :visible.sync="dialogFormVisible" :row="editRow" @success="onSearch" v-if="dialogFormVisible" />

    <!-- 查看调整记录弹窗 -->
    <record-dialog :visible.sync="recordDialogVisible" :row="recordRow" v-if="recordDialogVisible" />
  </content-panel>
</template>

<script>
import pagePathMixin from '@/utils/page-path-mixin';
import tableMixin from '@/utils/tableMixin';
import AddDialog from './add-dialog.vue';
import EditDialog from './edit-dialog.vue';
import RecordDialog from './record-dialog.vue';

export default {
  name: 'RetailPriceIndex',
  mixins: [pagePathMixin, tableMixin],
  components: { AddDialog, EditDialog, RecordDialog },
  data() {
    return {
      loading: false,
      searchForm: {
        productCode: '',
        productName: '',
        userName: '',
        startDate: null,
        endDate: null,
      },
      dialogFormVisible: false,
      addDialogVisible: false,
      editRow: {},
      recordDialogVisible: false,
      recordRow: {},
      tableData: {
        records: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
    };
  },
  methods: {
    handleEdit(rowData) {
      this.editRow = rowData;
      this.dialogFormVisible = true;
    },
    handleRecord(row) {
      this.recordRow = row;
      this.recordDialogVisible = true;
    },
    searchPage() {
      this.tableData.pageNum = 1;
      this.onSearch();
    },
    onSearch() {
      this.loading = true;
      const { userName, productCode, productName, startDate, endDate } = this.searchForm;
      const param = {
        pageNum: this.tableData.pageNum,
        pageSize: this.tableData.pageSize,
        filterData: {
          userName: userName,
          productCode: productCode,
          productName: productName,
          startDate: startDate,
          endDate: endDate,
        },
      };
      this.$q.product
        .listMngRetailPrice({
          data: param,
        })
        .then((data) => {
          if (!data) {
            return;
          }
          this.tableData = data.data;
          this.loading = false;
        });
    },
    initSearchForm() {
      this.searchForm = {
        productCode: '',
        productName: '',
        userName: '',
        startDate: null,
        endDate: null,
      };
    },
    resetForm() {
      this.initSearchForm();
      this.tableData.pageNum = 1;
      this.onSearch();
    },
    onSizeChange(pageSize) {
      this.tableData.pageSize = pageSize;
      this.tableData.pageNum = 1;
      this.onSearch();
    },
    onCurrentChange(pageNum) {
      this.tableData.pageNum = pageNum;
      this.onSearch();
    },
    // 清仓销售价系数维护导入
    importClearPrice() {
      this.openSubPage({
        path: '/dataImport/productClearPriceDataImport',
        query: {
          fileName: '清仓销售价系数维护_模板.xlsx',
          appCode: 'ec-pc-api',
        },
      });
    },
    // 产品价格系数维护导入
    importPriceCoefficient() {
      this.openSubPage({
        path: '/dataImport/productPriceCoefficientImport',
        query: {
          fileName: '产品价格系数维护_模板.xlsx',
          appCode: 'ec-pc-api',
        },
      });
    },
    // 产品基础价格维护导入
    importBasePrice() {
      this.openSubPage({
        path: '/dataImport/productRetailPriceDataImport',
        query: {
          fileName: '产品基础价格维护_模板.xlsx',
          appCode: 'ec-pc-api',
        },
      });
    },
    exportExcel() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      let params = {
        appCode: 'ec-pc-api',
        paramMap: {
          ...this.searchForm,
        },
        reportName: 'retailPriceExport',
      };
      this.$q.orderDate
        .importExcel({ data: params })
        .then((res) => {
          if (res.success) {
            this.$message.success('提交下载任务成功，请稍后到导出列表查阅！');
          } else {
            this.$message.error(res.message);
          }
        })
        .finally(() => {
          loading.close();
        });
    },
  },
  mounted() {
    this.onSearch();
  },
};
</script>

<style lang="stylus" scoped>
.footerBox
  text-align right

.search-box
  >>> .el-select, >>> .el-input
    width 240px !important

>>> .date-range .single-date
  width 110px !important

.wrap_tooltip
  display inline-block
  max-width 200px
  overflow hidden
  text-overflow ellipsis
  white-space nowrap
  cursor pointer
  height 28px
</style>
